import { render } from "./WhitePill.vue?vue&type=template&id=26d24c92&scoped=true"
import script from "./WhitePill.vue?vue&type=script&lang=js"
export * from "./WhitePill.vue?vue&type=script&lang=js"

import "./WhitePill.vue?vue&type=style&index=0&id=26d24c92&lang=scss&scoped=true"

import exportComponent from "/var/www/ascentcontrols/landingpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d24c92"]])

export default __exports__